// extracted by mini-css-extract-plugin
export var centerText = "_7r-8";
export var container = "_7r-0";
export var doughnutContainer = "_7r-7";
export var legend = "_7r-a";
export var legendItemColorDisplay = "_7r-b";
export var legendItemLabel = "_7r-d";
export var legendItemValue = "_7r-c";
export var lg = "_7r-5";
export var maxWidth = "_7r-9";
export var md = "_7r-4";
export var responsive = "_7r-6";
export var sm = "_7r-3";
export var xs = "_7r-2";
export var xxs = "_7r-1";